declare const THREE: any;

export class AutoScaleSprite extends (THREE.Sprite as { new(material): any; }) {

  protected width;
  protected height;
  static readonly Name = "autoScaleSprite";

  constructor(width: number, height: number, material?: any) {
    let mat = material;
    if (!mat) {
      mat = new THREE.SpriteMaterial({
        side: THREE.DoubleSide,
        depthWrite: false,
        depthTest: false,
        transparent: true,
        color: "#ffffff"
      });
    }
    super(mat);
    this.width = width;
    this.height = height;
    this.scale.set(this.width, this.height, 1);
    this.name = AutoScaleSprite.Name;
  }

  onBeforeRender(renderer, scene, camera) {
    if (camera instanceof THREE.PerspectiveCamera) {
      const scale = camera.position.length() / 1000;
      this.scale.set(this.width * scale, this.height * scale, 1);
    } else {
      this.scale.set(this.width, this.height, 1);
    }
  }

  updateMat(can) {
    this.material.map = new THREE.CanvasTexture(can);
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/AutoScaleSprite.ts